<form #docTypeForm="ngForm">

    <section class="header-title tw-mb-4">
    </section>
    <section class="tw-flex tw-flex-col tw-mb-3 tw-ml-3">
        <span class="p-float-label tw-w-[90%]">
            <input class="tw-w-full" type="text" [(ngModel)]="documentType.type" name="type" #type="ngModel" pInputText
                (keyup)="documentTypeChanged($event)" required />
            <label htmlFor="type">Type</label>
        </span>
        <p-message *ngIf="displayDocumentTypeWarning" severity="warn" [text]="documentTypeChangeWarning"></p-message>
    </section>
    <section class="tw-flex tw-flex-col tw-mb-3 tw-ml-3">
        <span [hidden]="type?.valid || type?.pristine" class="alert alert-danger">
            Name is required
        </span>
    </section>
    <section class="tw-flex tw-flex-col tw-mb-3 tw-ml-3">
        <span class="p-float-label tw-w-full">
            <p-inputMask mask="9.9" placeholder="1.0" class="tw-w-[6rem]" type="text" [(ngModel)]="documentType.version"
                name="version"></p-inputMask>
            <label htmlFor="version">Version</label>
        </span>
    </section>
    <section class="tw-flex tw-flex-col tw-mb-3 tw-ml-3">
        <span class="p-float-label tw-w-full">
            <input class="tw-w-[70%]" type="text" [(ngModel)]="documentType.metadata.category" name="category"
                pInputText />
            <label htmlFor="category">Category</label>
        </span>
    </section>
    <section class="tw-flex tw-flex-col tw-mb-3 tw-ml-3">
        <span class="p-float-label tw-w-full">
            <input class="tw-w-full" type="text" [(ngModel)]="documentType.description" name="description" pInputText />
            <label htmlFor="description">Description</label>
        </span>
    </section>
    <section class="tw-flex tw-flex-col tw-mb-3 tw-ml-3">
        <div class="tw-w-full tw-mt-4">
            <label htmlFor="active">Active</label>
            <p-selectButton [options]="defaultSelectButtonOptions" [(ngModel)]="documentType.active" name="active"
                optionLabel="label" optionValue="value"></p-selectButton>
        </div>
    </section>
    <section class="tw-flex tw-flex-col tw-mb-3 tw-ml-3">
        <div class="tw-w-full tw-mt-4">
            <label htmlFor="showInUi">Show In UI</label>
            <p-selectButton [options]="defaultSelectButtonOptions" [(ngModel)]="documentType.showInUI" name="showInUI"
                optionValue="value"></p-selectButton>
        </div>
    </section>
    <section class="tw-flex tw-flex-row tw-basis tw-h-8 tw-mt-8 tw-p-0 tw-w-full tw-justify-end">
        <div>
            <button [disabled]="!docTypeForm.dirty || !docTypeForm.valid || saving" pButton icon="fal fa-save"
                label="Save" (click)="saveChanges()" class="tw-mr-2"></button>
            <button [disabled]="!docTypeForm.dirty || saving" pButton icon="fal fa-undo" label="Clear"
                (click)="resetForm()" class="p-button-warning p-button-outlined tw-mr-2"></button>
            <button [disabled]="this.isNewDocumentType" pButton icon="fal fa-trash" label="Delete"
                (click)="delete($event)" class="p-button-warning p-button-outlined tw-mr-2"></button>
        </div>
    </section>
</form>

<section class="header-title tw-mb-4 tw-mt-16">
    <p-fieldset legend="Functional Areas">
        <section class="tw-flex tw-flex-col tw-mb-4 tw-ml-4">
            <div class="tw-w-full tw-mt-4">
                <p-checkbox [disabled]="isNewDocumentType" label="eLynk" (onChange)="deleteElynk($event)"
                    [(ngModel)]="functionalAreasConfig.elynk" [binary]="true" name="functionalAreaElynk"></p-checkbox>
            </div>
        </section>
        <section class="tw-flex tw-flex-col tw-mb-4 tw-ml-4">
            <div class="tw-w-full tw-mt-4">
                <p-checkbox [disabled]="isNewDocumentType" label="Template Manager"
                    (onChange)="deleteTemplateManager($event)" [(ngModel)]="functionalAreasConfig.templateManager"
                    [binary]="true" name="functionalAreaTemplate"></p-checkbox>
            </div>
        </section>
        <section class="tw-flex tw-flex-col tw-mb-4 tw-ml-4">
            <div class="tw-w-full tw-mt-4">
                <p-checkbox [disabled]="isNewDocumentType" label="Document Classification"
                    (onChange)="deleteClassification($event)" [(ngModel)]="functionalAreasConfig.documentClassification"
                    [binary]="true" name="functionalAreaClassification"></p-checkbox>
            </div>
        </section>

    </p-fieldset>
</section>

<p-confirmDialog key="DocTypeDialog" header="Document Types" appendTo="body"
    message="{{documentTypeChangeWarning}}.  Are you sure you want to delete this?"
    rejectButtonStyleClass="p-button-warning p-button-outlined">
</p-confirmDialog>
